(function() {
  function fixAllProductCards() {
    
    const productCards = document.querySelectorAll('.collection-grid .grid-product__content, .featured-collection .grid-product__content, .product-recommendations .grid-product__content, .recently-viewed .grid-product__content');
    
    productCards.forEach(card => {
      try {
        const vendorElements = card.querySelectorAll('.grid-product__vendor');
        
        if (vendorElements.length > 1) {
          for (let i = 1; i < vendorElements.length; i++) {
            vendorElements[i].parentNode.removeChild(vendorElements[i]);
          }
        }
        
        const meta = card.querySelector('.grid-product__meta');
        const title = meta ? meta.querySelector('.grid-product__title') : null;
        const price = meta ? meta.querySelector('.grid-product__price') : null;
        
        if (vendorElements.length === 0 && meta) {
          const newVendor = document.createElement('div');
          newVendor.className = 'grid-product__vendor';
          
          const productHandle = card.closest('[data-product-handle]')?.dataset.productHandle;
          
          if (productHandle) {
            newVendor.textContent = productHandle.split('-')[0].charAt(0).toUpperCase() + 
                                   productHandle.split('-')[0].slice(1);
          } else {
            newVendor.textContent = 'Vendor';
          }
          
          if (title && price) {
            meta.insertBefore(newVendor, price);
          }
        } 
        else if (vendorElements.length === 1) {
          const vendor = vendorElements[0];
          if (meta && vendor.parentNode === meta) {
            if (title && price) {
              const titleNextSibling = title.nextElementSibling;
              if (titleNextSibling !== vendor) {
                vendor.parentNode.removeChild(vendor);
                meta.insertBefore(vendor, price);
              }
            }
          } 
          else if (meta) {
            vendor.parentNode.removeChild(vendor);
            if (title && price) {
              meta.insertBefore(vendor, price);
            }
          }
        }
      } catch (e) {}
    });
  }
  
  function initProductCardFixes() {
    const productSections = document.querySelector('.collection-grid, .featured-collection, .product-recommendations, .recently-viewed');
    if (!productSections) return;
    
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      setTimeout(fixAllProductCards, 500);
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        setTimeout(fixAllProductCards, 500);
      });
    }
    
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length > 0 || 
            mutation.type === 'attributes' && mutation.target.classList.contains('grid-product__content')) {
          setTimeout(fixAllProductCards, 100);
        }
      });
    });
    
    if (document.readyState === 'complete' || document.readyState === 'interactive') {
      const productSections = document.querySelectorAll('.collection-grid, .featured-collection, .product-recommendations, .recently-viewed');
      productSections.forEach(section => {
        if (section) {
          observer.observe(section, { 
            childList: true, 
            subtree: true,
            attributes: true,
            attributeFilter: ['class']
          });
        }
      });
    } else {
      document.addEventListener('DOMContentLoaded', function() {
        const productSections = document.querySelectorAll('.collection-grid, .featured-collection, .product-recommendations, .recently-viewed');
        productSections.forEach(section => {
          if (section) {
            observer.observe(section, { 
              childList: true, 
              subtree: true,
              attributes: true,
              attributeFilter: ['class']
            });
          }
        });
      });
    }
    
    setTimeout(fixAllProductCards, 1000);
    setTimeout(fixAllProductCards, 2000);
  }
  
  initProductCardFixes();
})();